import { assert } from '@ember/debug';
import { computed } from '@ember/object';

/**
 * Makes a ternary computed property. Sample usage:
 *
 *   const User = Ember.Object.extend({
 *     name: attr(String),
 *     defaultName: attr(String),
 *     hasOwnName: computed.notEmpty('name'),
 *     displayName: computed.if('hasOwnName', { then: 'name', else: 'defaultName' })
 *   });
 *
 * First argument should be a key to a property that will be evaluated as a boolean.
 * Second argument should be an options object that defines both `then` and `else` as keys
 * to other properties on the object.
 *
 * @param {string} conditionProperty
 * @param {object} opts
 * @param {string} [opts.then]
 * @param {string} [opts.else]
 * @returns {Ember.ComputedProperty}
 */
export default function condition(conditionProperty, opts = {}) {
  if (!opts || !opts.then || !opts.else) {
    assert('must provide both `then` and `else` options to `condition`', opts.then && opts.else);
  }
  return computed(conditionProperty, opts.then, opts.else, function () {
    if (this.get(conditionProperty)) {
      return this.get(opts.then);
    } else {
      return this.get(opts.else);
    }
  });
}